import { AnonymousViewActionTypes } from './types';
import { action } from 'typesafe-actions';

export const getAnonymousEnquiryStart = (payload: any) =>
  action(AnonymousViewActionTypes.GET_ANONYMOUS_ENQUIRY_START, payload);
export const getAnonymousEnquirySuccess = (payload: any) =>
  action(AnonymousViewActionTypes.GET_ANONYMOUS_ENQUIRY_SUCCESS, payload);
export const getAnonymousEnquiryFailure = (error: string) =>
  action(AnonymousViewActionTypes.GET_ANONYMOUS_ENQUIRY_FAILURE, error);

export const getAnonymousEnquiryAutoRenewPropertiesStart = (payload: any) =>
  action(
    AnonymousViewActionTypes.GET_ANONYMOUS_ENQUIRY_AUTO_RENEW_PROPERTIES_START,
    payload
  );
export const getAnonymousEnquiryAutoRenewPropertiesSuccess = (payload: any) =>
  action(
    AnonymousViewActionTypes.GET_ANONYMOUS_ENQUIRY_AUTO_RENEW_PROPERTIES_SUCCESS,
    payload
  );
export const getAnonymousEnquiryAutoRenewPropertiesFailure = (error: string) =>
  action(
    AnonymousViewActionTypes.GET_ANONYMOUS_ENQUIRY_AUTO_RENEW_PROPERTIES_FAILURE,
    error
  );

export const getAnonymousCredentialStart = (payload: any) =>
  action(AnonymousViewActionTypes.GET_ANONYMOUS_CREDENTIAL_START, payload);
export const getAnonymousCredentialSuccess = (payload: string) =>
  action(AnonymousViewActionTypes.GET_ANONYMOUS_CREDENTIAL_SUCCESS, payload);
export const getAnonymousCredentialFailure = (error: string) =>
  action(AnonymousViewActionTypes.GET_ANONYMOUS_CREDENTIAL_FAILURE, error);
